import React from "react";
import styled from "styled-components";
import { Typography } from "antd";
import { Trans } from "react-i18next";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { ReactComponent as HazardTriangleIcon } from "../../../assets/svg/hazardTriangle.svg";
import { ERROR_50, ERROR_200, ERROR_600, PRIMARY_600 } from "../../../constant/colors";
import { fontWeights, sizes } from "../../../constant/styles";

const { Text } = Typography;

const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 6px;
  background-color: ${ERROR_50};
  border: 1px solid ${ERROR_200};
  border-radius: 8px;
`;

const ManageDetailsLink = styled.span`
  color: ${PRIMARY_600};
  font-size: ${sizes.small};
  font-weight: ${fontWeights.semibold};
  line-height: 1.5em;
  cursor: pointer;
  text-decoration: underline;
  text-underline-position: from-font;

  &:hover {
    opacity: 0.8;
  }
`;
// TODO:: add icon for error alert
const HazardIcon = styled(HazardTriangleIcon)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

const AlertMessage = styled(Text)`
  font-size: ${sizes.small};
  font-weight: ${fontWeights.semibold};
  line-height: 1.5em;
  color: ${ERROR_600};
`;

const AlertAction = styled.div`
  font-size: ${sizes.small};
  font-weight: ${fontWeights.semibold};
  line-height: 1.5em;
`;

/**
 * ErrorAlert component
 * Displays an error alert with icon, message, and optional action content
 */
const RequestConsentLinkErrorAlert = ({ message }) => {
  const { patientId, journeyId } = useParams();
  const history = useHistory();
  const location = useLocation();

  const handleManagePatientDetailsClick = () => {
    history.push(`/patient/${patientId}/journey/${journeyId}/edit`, {
      path: location.pathname
    });
  };

  return (
    <AlertContainer>
      <HazardIcon />
      <AlertContent>
        <AlertMessage>{message}</AlertMessage>
        <AlertAction>
          <Trans
            i18nKey="consent.forms.request.add_missing_details_action"
            components={{
              ManagePatientDetailsLink: <ManageDetailsLink onClick={handleManagePatientDetailsClick} />
            }}
          />
        </AlertAction>
      </AlertContent>
    </AlertContainer>
  );
};

export default RequestConsentLinkErrorAlert;
